




























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositCoolingOffSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositCoolingOffSettingsRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'AccountDepositCoolingOffSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountDepositCoolingOffSettingsRequest = new UpdateAccountDepositCoolingOffSettingsRequest(DepositAccountSettingsModule.settings.depositCoolingOffSettings, new Date());
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositCoolingOffSettingsRequest(DepositAccountSettingsModule.settings.depositCoolingOffSettings, new Date());
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositCoolingOffSettings;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
           return;
        }
        else {
            this.dialog = false;
            this.request.coolingOffPeriodValue = +this.request.coolingOffPeriodValue;
            await DepositAccountSettingsModule.editDepositCoolingOffSettings(this.request);
        }
    }

}
